import script from "./HeaderComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderComponents.vue?vue&type=script&setup=true&lang=js"

import "./HeaderComponents.vue?vue&type=style&index=0&id=08bff763&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08bff763"]])

export default __exports__